import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Minimal production-only client error reporter
const safeReportError = async (message, context = {}) => {
  try {
    if (process.env.NODE_ENV !== 'production') return;
    const payload = {
      message: String(message || 'unknown_error'),
      context: { location: window?.location?.pathname || '/', ...context },
      ts: Date.now(),
    };
    await fetch('/api/client-logs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (_) {}
};

// 🛡️ SECURITY: Register service worker with integrity checks
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      // Security: Add integrity checks for service worker
      const swUrl = process.env.REACT_APP_SW_URL || '/sw.js';
      const swIntegrity = process.env.REACT_APP_SW_INTEGRITY;
      // Enforce same-origin SW URL
      const isSameOrigin = typeof swUrl === 'string' && (swUrl.startsWith('/') || swUrl.startsWith(window.location.origin + '/'));
      if (!isSameOrigin) {
        safeReportError('sw_url_not_same_origin');
        return;
      }
      
      if (swIntegrity) {
        // Register with integrity check if available
        navigator.serviceWorker.register(swUrl, {
          updateViaCache: 'none',
          scope: '/'
        }).catch(() => {
          safeReportError('service_worker_registration_failed', { mode: 'integrity' });
        });
      } else {
        // Fallback registration without integrity check
        navigator.serviceWorker.register(swUrl).catch(() => {
          safeReportError('service_worker_registration_failed', { mode: 'basic' });
        });
      }
    });
  } else {
    // Dev: unregister any existing SW to avoid caching dev assets with wrong MIME
    navigator.serviceWorker.getRegistrations &&
      navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => {
  // Send Core Web Vitals to Google Analytics (if gtag is available)
  if (window.gtag) {
    window.gtag('event', metric.name, {
      value: metric.value,
      event_category: 'Web Vitals',
      non_interaction: true,
    });
  }
});
